import { BRAND } from './brand';
import { formatReportJobDate } from './report/jobReport';

/**
 * הודעת עדכון ממותגת לשיתוף ידני בוואטסאפ, כשמנהל משנה תאריך, שעה או מיקום.
 * אין שליחה אוטומטית ואין WhatsApp API — המנהל מעתיק או פותח את קישור wa.me בעצמו.
 */

export interface JobForMessage {
  name: string;
  date: string;
  reportTime: string;
  location: string;
}

export type ChangedField = 'date' | 'reportTime' | 'location';

const FIELD_LABELS: Record<ChangedField, string> = {
  date: 'תאריך',
  reportTime: 'שעת התייצבות',
  location: 'מיקום',
};

export function buildJobUpdateMessage(before: JobForMessage, after: JobForMessage, signature: string = BRAND.whatsapp.signature): string | null {
  const changed = (['date', 'reportTime', 'location'] as ChangedField[]).filter((f) => before[f] !== after[f]);
  if (changed.length === 0) return null;

  const show = (f: ChangedField, j: JobForMessage) => (f === 'date' ? formatReportJobDate(j.date) : j[f]);
  const lines = [
    `*${BRAND.name} — עדכון לעבודה*`,
    `*${after.name}*`,
    '',
    ...changed.map((f) => `${FIELD_LABELS[f]}: ~${show(f, before)}~ ← *${show(f, after)}*`),
    '',
    'פרטי העבודה המעודכנים:',
    `📅 ${formatReportJobDate(after.date)}`,
    `🕐 ${after.reportTime}`,
    `📍 ${after.location}`,
    '',
    signature,
  ];
  return lines.join('\n');
}

/** קישור שפותח את וואטסאפ עם ההודעה מוכנה — בלי נמען, המנהל בוחר למי לשלוח. */
export function whatsappShareUrl(message: string): string {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
